import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { ReportType } from "../../../../../../../api/types/svTypes.ts";
import { useEnhancedBiApiClientProvider } from "../../../contexts/ApiClientProviderContext";
import { useDefineEditReportData } from "../../../hooks/useDefineEditReportData";
import { selectCurrentReport, selectCurrentReportType } from "../../../store/selectors/currentReportSelectors";
import ApplyingDialog from "../../common/dialogs/ApplyingDialog";
import DrillDownEntry from "../common/drillDown/DrillDownEntry";
import EditCommonDataProvider from "../common/EditCommonDataProvider";
import useLedgerBasis from "../common/hooks/useLedgerBasis";
import ReportNotFoundOrAccessForbidden from "../ReportNotFoundOrAccessForbidden";
import EditReportPage from "./EditReportPage";

const EditRoot = () => {
  const { id } = useParams();
  const report = useSelector(selectCurrentReport);
  const reportType = useSelector(selectCurrentReportType);
  const { getReportsUrl } = useEnhancedBiApiClientProvider();
  useLedgerBasis();

  const { showReportNotFound, isSwitchingReport, isFetching } = useDefineEditReportData(id ?? "");

  if (id === undefined) {
    return <Navigate to={""} />;
  }

  if (showReportNotFound === true || (report && reportType !== ReportType.Tabular)) {
    return <ReportNotFoundOrAccessForbidden getReportsUrl={getReportsUrl} />;
  }

  const isFetchingEditReport = !isSwitchingReport && isFetching;

  if (report === undefined || isFetchingEditReport) {
    return <InlineLoader text="Loading metadata, it won't take long..." />;
  }

  return (
    <EditCommonDataProvider isApiReport>
      <Stack sx={{ bgcolor: "background.paper", height: "100%", width: "100%" }}>
        <EditReportPage report={report} />
        <DrillDownEntry reportId={id} />
        {isSwitchingReport && <ApplyingDialog open text="Loading report..." />}
      </Stack>
    </EditCommonDataProvider>
  );
};

export default EditRoot;
